// Utility function to get the current day and time in minutes
function getCurrentTimeInMinutes() {
  const now = new Date();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  return hours * 60 + minutes;
}

// Function to get collection message for current day
export function getClickAndCollMessage() {
  const dayOfWeek = new Date().getDay();
  const timeInMinutes = getCurrentTimeInMinutes();
  const translationObject: {key: string, fallback: string} = {key: '', fallback: ''};

  if (dayOfWeek >= 1 && dayOfWeek <= 5) { // Monday to Friday
    if (timeInMinutes >= 420 && timeInMinutes <= 1040) { // Between 7:00 (420) and 17:40 (1040)
      translationObject['key'] = 'PDP-clickAndCollectWeekdayAfter10Min';
      translationObject['fallback'] = '<span class="font-semibold">Bestel nu</span> en haal <span class="font-semibold">na 10 minuten binnen openingsuren (tot 18u) op</span>';
    } else if (timeInMinutes > 1040 && timeInMinutes <= 1440) { // Between 17:41 and 00:00 (1440)
      translationObject['key'] = 'PDP-clickAndCollectWeekdayTomorrow'
      translationObject['fallback'] = '<span class="font-semibold">Bestel nu</span> en haal <span class="font-semibold">morgen op tijdens openingsuren (7 tot 18u)</span>';
    } else if (timeInMinutes >= 1 && timeInMinutes <= 420) { // Between 0:01 and 7:00
      translationObject['key'] = 'PDP-clickAndCollectWeekdayToday'
      translationObject['fallback'] = '<span class="font-semibold">Bestel nu</span> en haal <span class="font-semibold">vandaag op tijdens openingsuren (7 tot 18u)</span>';
    }
  } else if (dayOfWeek === 6) { // Saturday
    if (timeInMinutes >= 480 && timeInMinutes <= 1000) { // Between 8:00 (480) and 16:40 (1000)
      translationObject['key'] = 'PDP-clickAndCollectSaturdayAfter10Min';
      translationObject['fallback'] = '<span class="font-semibold">Bestel nu</span> en haal <span class="font-semibold">na 10 minuten binnen openingsuren (tot 17u) op</span>';
    } else if (timeInMinutes >= 1 && timeInMinutes < 480) { // Between 0:01 and 8:00
      translationObject['key'] = 'PDP-clickAndCollectSaturdayToday';
      translationObject['fallback'] = '<span class="font-semibold">Bestel nu</span> en haal <span class="font-semibold">vandaag op tijdens openingsuren (8 tot 17u)</span>';
    } else if (timeInMinutes > 1000 && timeInMinutes <= 1440) { // Between 16:41 and Sunday 0:00 (1440)
      translationObject['key'] = 'PDP-clickAndCollectSaturdayToMonday';
      translationObject['fallback'] = '<span class="font-semibold">Bestel nu</span> en verzamelen van  <span class="font-semibold">Maandag (open om 7u)</span>';
    }
  } else if (dayOfWeek === 0) { // Sunday
    translationObject['key'] = 'PDP-clickAndCollectSunday';
    translationObject['fallback'] = '<span class="font-semibold">Bestel nu</span> en haal af vanaf <span class="font-semibold">maandag (open om 7u)</span>';
  }

  return translationObject;
};

// Function to get the collection message for the next day
export function getNextDayCollMessage() {
  const dayOfWeek = new Date().getDay();
  const timeInMinutes = getCurrentTimeInMinutes();
  const translationObject: {key: string, fallback: string} = {key: '', fallback: ''};

  // 1.) Monday to Thursday, between 01:00 to 22:00
  if ((dayOfWeek >= 1 && dayOfWeek <= 4) && (timeInMinutes >= 60 && timeInMinutes <= 1320)) {
    translationObject['key'] = 'PDP-nextDayCollectionTommorow';
    translationObject['fallback'] = '<span class="font-semibold">Bestelling voor</span> afhaling <span class="font-semibold">morgen.</span>';
  }
  // 2.) Monday to Wednesday, between 22:00 to 00:10
  else if ((dayOfWeek >= 1 && dayOfWeek <= 3) && (timeInMinutes >= 1320 && timeInMinutes <= 10)) {
    translationObject['key'] = 'PDP-nextDayCollectionDayAfterTommorow';
    translationObject['fallback'] = '<span class="font-semibold">Bestel</span> voor afhaling <span class="font-semibold">overmorgen.</span>';
  }
  // 3.) Thursday to Saturday, between 22:00 to 15:00
  else if ((dayOfWeek >= 4 && dayOfWeek <= 6) && (timeInMinutes >= 1320 || timeInMinutes <= 900)) {
    translationObject['key'] = 'PDP-nextDayCollectionMonday';
    translationObject['fallback'] = '<span class="font-semibold">Bestelling voor</span> afhaling op <span class="font-semibold">maandag.</span>';
  }
  // 4.) Saturday after 15:00 till Monday 01:00
  else if (dayOfWeek === 6 && (timeInMinutes >= 900 && timeInMinutes <= 1260) || (dayOfWeek === 0 && timeInMinutes <= 60)) {
    translationObject['key'] = 'PDP-nextDayCollectionDayAfterTommorow';
    translationObject['fallback'] = '<span class="font-semibold">Bestel</span> voor afhaling <span class="font-semibold">overmorgen.</span>';
  }

  return translationObject;
};

// Function to get the order message based on current time and day
export function getOrderMessage() {
  const now = new Date();
  const dayOfWeek = now.getDay();
  const timeInMinutes = getCurrentTimeInMinutes();
  const translationObject: {key: string, fallback: string} = {key: '', fallback: ''};

  // Monday 0:00 to Friday 22:00
  if ((dayOfWeek >= 1 && dayOfWeek <= 4) || (dayOfWeek === 5 && timeInMinutes <= 1320)) {
    translationObject['key'] = 'PDP-getOrderTomorrow';
    translationObject['fallback'] = '<span class="font-semibold">Bestel vóór 22.00 uur</span> voor de volgende levering <span class="font-semibold">Morgen.</span>';
  }
  // Friday 22:01 to Saturday 15:00
  else if ((dayOfWeek === 5 && timeInMinutes > 1320) || (dayOfWeek === 6 && timeInMinutes <= 900)) {
    translationObject['key'] = 'PDP-getOrderOnMonday';
    translationObject['fallback'] = '<span class="font-semibold">Bestel vóór 15.00 uur</span> op zaterdag, voor levering op <span class="font-semibold">maandag.</span>';
  }
  // Saturday 15:01 to Monday
  else {
    translationObject['key'] = 'PDP-getOrderOnTuesday';
    translationObject['fallback'] = '<span class="font-semibold">Bestel na 15.00 uur</span> op zaterdag, voor bezorging op <span class="font-semibold">dinsdag.</span>';
  }

  return translationObject;
}

export function getProCardOrderInfo() {
  const translationObject: { key: string; fallback: string } = {
    key: 'Procard-dashboardUpperSection',
    fallback:
      `Op deze pagina kun je een overzicht vinden van al jouw bestellingen betaald met PRO-kaart. Tevens kun je een kopie van jouw PRO-kaart facturen downloaden en printen door de desbetreffende bestelling te selecteren. Bestellingen geplaatst zonder PRO-kaart kun je in jouw <a href="https://www.toolstation.nl/account/order-history" class="text-primary underline font-semibold">bestelgeschiedenis</a> vinden. Om de originele factuur te verkrijgen, verwijzen we je naar ons factuurplatform <a href="https://secure.order2cash.com/i2d/#8BQ1X1L5vG7J6x1oAUQaig" class="text-primary underline font-semibold">Bestel 2 contant</a>. Hier kun je de factuur in verschillende formaten downloaden en aanvragen om deze per e-mail te ontvangen. Neem bij vragen contact op met ons op via 071-7470064 of pro{'@'}toolstation.nl.`,
  };

 return translationObject;
}